export enum UploadTypeEnum {
  URL = 'URL',
  LOCAL_DISK = 'LOCAL_DISK'
}
